import { isMedical } from '@/entities/item/helpers/is-medical';
import type { Item } from '@/entities/item/schemas/item';
import { parseNumber } from '@/shared/components/form/parse-number';
import { parseTags } from '@/shared/components/form/parse-tags';
import { parseEuros } from '@/shared/lib/money/parse-euros';
import type { ItemFormValues } from '../schemas/item-form-values';

/** Form values → record data; fields this form doesn't know about are kept from `base`. */
export function fromItemForm(values: ItemFormValues, base?: Item): Partial<Item> {
  const medical = isMedical(values.category);
  return {
    ...base,
    name: values.name,
    category: values.category,
    brand: values.brand,
    quantity: parseNumber(values.quantity) ?? 0,
    unit: values.unit || 'ud',
    min_quantity: parseNumber(values.min_quantity),
    location: values.location,
    tags: parseTags(values.tags),
    price_cents: parseEuros(values.price),
    store: values.store,
    url: values.url,
    purchased_on: values.purchased_on,
    expires_on: values.expires_on,
    best_before: values.best_before,
    replace_on: values.replace_on,
    shelf_life_months: parseNumber(values.shelf_life_months),
    active_ingredient: medical ? values.active_ingredient : undefined,
    dosage: medical ? values.dosage : undefined,
    notes: values.notes,
    attachments: values.attachments,
  };
}
